import React, { useState } from 'react'
 
import UnitList from './UnitList';
import UnitForm from './UnitForm';

const Unit= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <UnitForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <UnitList addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}
  
    </>
  )
}

export default Unit